<template>
  <div class="form-horizontal">
    <div class="form-group">
      <label class="col-sm-2 control-label">瑕疵</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" placeholder="瑕疵" v-model="flaw.text" @input="onPhoneInput">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['flaw'],
  methods: {
    onPhoneInput() {
      this.$emit('onPhoneInput')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/forms/Flaw.vue